import {
  GetMaterialsForSupplierInput,
  GetSuppliersInput,
  PaginationInput,
  PurchaseOrderFilterInput,
} from '@/gql/graphql';

const supplierKeys = {
  all: ['suppliers'],
  search: (input: GetSuppliersInput, pagination: PaginationInput) => [
    ...supplierKeys.all,
    'search',
    input,
    pagination,
  ],
  supplier: (id: string) => [...supplierKeys.all, 'supplier', id] as const,
  purchaseOrders: (
    supplierId: string,
    input?: PurchaseOrderFilterInput,
    pagination?: PaginationInput
  ) => {
    return [
      ...supplierKeys.supplier(supplierId),
      'purchaseOrders',
      input || null,
      pagination || null,
    ] as const;
  },
  materials: (
    supplierId: string,
    input?: GetMaterialsForSupplierInput,
    pagination?: PaginationInput
  ) => {
    return [
      ...supplierKeys.supplier(supplierId),
      'materials',
      input || null,
      pagination || null,
    ] as const;
  },
  branches: (
    supplierId: string,
    input?: GetMaterialsForSupplierInput,
    pagination?: PaginationInput
  ) => {
    return [
      ...supplierKeys.supplier(supplierId),
      'branches',
      input || null,
      pagination || null,
    ] as const;
  },
  infiniteSuppliers: (input?: GetSuppliersInput) => {
    if (!input) {
      return [...supplierKeys.all, 'infiniteSuppliers'] as const;
    }

    return [...supplierKeys.all, 'infiniteSuppliers', input] as const;
  },
};

export default supplierKeys;
